var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0015 1.87501C10.4194 1.87407 9.8451 2.00048 9.3243 2.2442C8.8035 2.48791 8.35054 2.8422 8.00146 3.27888C7.52869 2.68916 6.87008 2.25375 6.11882 2.03426C5.36756 1.81478 4.5617 1.82233 3.81528 2.05585C3.06885 2.28937 2.41965 2.73704 1.95955 3.3355C1.49944 3.93396 1.25173 4.65292 1.25146 5.39063C1.25146 9.60134 7.49152 12.9258 7.75714 13.0652C7.83179 13.1044 7.91591 13.125 8.00146 13.125C8.08702 13.125 8.17114 13.1044 8.24579 13.0652C9.39345 12.4351 10.4706 11.6983 11.4609 10.866C13.6443 9.02373 14.7515 7.18154 14.7515 5.39063C14.7503 4.45855 14.3549 3.56495 13.6519 2.90587C12.9489 2.2468 11.9957 1.87606 11.0015 1.87501V1.87501Z",
    fill: "#FF6978"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/Heart.439308e77293b33474c3e9d9c95bf8c1.svg";
export { ForwardRef as ReactComponent };